require('./support-template.html');

exports.inject = function(module) {
  module.config(['$routeProvider', function($routeProvider) {
    $routeProvider.when('/support', {
      templateUrl: 'support-template.html',
      controller: 'SupportController',
    });
   
  }]);

  module.controller('SupportController', exports.controller);
  exports.controller.$inject = [];  
};

exports.controller = function() {
  
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/support/support-controller.js
 ** module id = 313
 ** module chunks = 0
 **/